import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@design-system';

import { Loader2 } from 'lucide-react';

interface PartnerDisconnectDialogProps {
  open: boolean;
  contactName: string;
  isDisconnecting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Confirms fully removing a connection: the contact loses access to every client shared with them
// and the link is torn down. To pause sharing without disconnecting, the advisor uses the
// per-contact "Stop sharing" toggle instead.
export function PartnerDisconnectDialog({
  open,
  contactName,
  isDisconnecting,
  onConfirm,
  onCancel,
}: PartnerDisconnectDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={isOpen => !isOpen && !isDisconnecting && onCancel()}
    >
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-primary-dark">
            Remove your connection with {contactName}?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-foreground">
            {contactName} will lose access to every client you've shared with them, and the
            connection will be removed. You can reconnect later if you change your mind.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isDisconnecting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDisconnecting}
          >
            {isDisconnecting ? (
              <>
                <Loader2 className="animate-spin" />
                Removing…
              </>
            ) : (
              'Remove connection'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
